export const firebaseConfig = {
  apiKey: "AIzaSyCJQoD5RlFJHQfg_fKpHSCWDIU0ARlnbAA",
  authDomain: "fir-hosting-practice-8a078.firebaseapp.com",
  databaseURL: "https://fir-hosting-practice-8a078.firebaseio.com",
  projectId: "fir-hosting-practice-8a078",
  storageBucket: "fir-hosting-practice-8a078.appspot.com",
  messagingSenderId: "881819980038",
  appId: "1:881819980038:web:fa1827cb9815af58b30e87",
  measurementId: "G-YX7CD8ZFML"
};